import { useState } from "react";

export default function useRequiredFields({ form, required, message }) {
  const [errors, setErrors] = useState({});
  const [showWarning, setShowWarning] = useState(false);

  const normalize = (v) => (v === null || v === undefined ? "" : String(v).trim());

  const validate = () => {
    const next = {};

    Object.entries(required).forEach(([field, rule]) => {
      if (rule === true) {
        if (!normalize(form[field])) next[field] = true;
      } else if (typeof rule === "function") {
        const ok = !!rule(form);
        if (!ok) next[field] = true;
      }
    });

    setErrors(next);

    const ok = Object.keys(next).length === 0;
    setShowWarning(!ok);

    if (!ok) alert(message || "⚠️ Preenchimento obrigatório! Verifique os campos em vermelho.");

    return ok;
  };

  const clearError = (field) => {
    setErrors((prev) => {
      if (!prev[field]) return prev;
      const copy = { ...prev };
      delete copy[field];
      return copy;
    });
  };

  const fieldProps = (field, extra = {}) => ({
    name: field,
    value: form[field] ?? "",
    className: `${extra.className || ""} ${errors[field] ? "campo-obrigatorio-erro" : ""}`.trim(),
    onChange: (e) => {
      extra.onChange?.(e);
      clearError(field);
    },
    ...extra,
  });

  return { errors, validate, clearError, fieldProps, showWarning };
}
